export const documentOrder: Record<string, number> = {
  DOCUMENT_DEFICIENCY: 1,
  SERVICE_AGREEMENT: 2,
  TERMS_CONDITIONS: 3,
  APPENDIX: 4,
  CUSTOM_AGREEMENT: 5,
};

export const EMAIL_CONTENT = {
  subject: {
    id: 'Permohonan Tanda Tangan Perjanjian Kerjasama Secara Manual',
    en: 'Request for Manual Signature of Cooperation Agreement',
  },
  body: {
    id: `Halo ${
      import.meta.env.VITE_BRAND_NAME
    },\nDengan ini, saya yang berinformasi di bawah ini ingin mengajukan permohonan tanda tangan perjanjian kerjasama secara manual. Berikut adalah detailnya:\n\n   Username:\n   Email Penanggung Jawab Kerja Sama:\n   Product yang ingin digunakan: Terima Uang/ Kirim Uang/ Corporate Card\n\nAtas perhatian dan kerja samanya, saya ucapkan terima kasih.`,
    en: `Hello ${
      import.meta.env.VITE_BRAND_NAME
    },\nI am writing to request a manual signature for the cooperation agreement. Please find the details below:\n\n   Username:\n   Email of Cooperation PIC:\n   Product(s) to be used: Receive Money / Send Money / Corporate Card\n\nThank you for your attention and cooperation.`,
  },
};
